<template>
    <div class="bto-sb-horse-event-item" :class="{ 'bto-sb-horse-event-item-tricast': betType !== RACING_BETTING_TYPES.WINNER_EW }">
      <div v-if="status === hrStatuses.RESULTS" class="bto-sb-horse-event-item-num">
        {{ runner.runnerPosition || "--" }}
      </div>
      <div class="bto-sb-horse-event-item-content">
        <div class="bto-sb-horse-event-item-no" v-if="selectedSport === horseRacingSportId">
          <span>{{ runner.runnerNumber }}</span>
          <span>({{ runner.age }})</span>
          <div class="bto-sb-horse-event-item-stat">
            <!-- <a :title="$translate.text('Match.Statistics.Title')"></a> -->
          </div>
        </div>
        <div class="bto-sb-horse-event-item-img">
          <img
            :src="altImgSrc"
            v-show="showImg"
            @load="setAltImg"
            @error="altImgSrc = ''"
            v-if="altImgSrc" />
          <img :src="imgSrc" v-if="!showImg" />
        </div>
        <div class="bto-sb-horse-event-item-name">
          <span class="bto-sb-horse-racername">{{ runner.name }}</span>
          <span class="bto-sb-horse-jockey" v-if="selectedSport === horseRacingSportId"
            ><i>{{ t("HR.J") }}</i
            >{{ runner.jockey || "--" }}</span
          >
          <span class="bto-sb-horse-trainer"
            ><i>{{ t("HR.T") }}</i
            >{{ truncateString(runner.trainer, 20) || "--" }}</span
          >
          <span class="bto-sb-horse-raced" v-if="raceType !== 'Flat'"
            ><i>{{ t("HR.F") }}</i
            >{{ runner.prevPlaces || "--" }}</span
          >
          <span class="bto-sb-horse-raced" v-if="raceType === 'Flat'">
            <i>{{ t("HR.F") }}</i>
            {{ runner.prevFlatPlaces || "--" }}
          </span>
        </div>
        <div class="bto-sb-horse-event-item-odd" v-if="runner.outcomes.length && betType === RACING_BETTING_TYPES.WINNER_EW">
          <div
            :class="[
              'bto-sb-event-odd',
              {
                'bto-sb-event-odd-active': isOddSelected,
                'bto-sb-odd-lock':
                  !runner.outcomes[0].isPublished &&
                  +runner.outcomes[0].outcome > 1 &&
                  status !== 4,
              },
              quickBetClasses,
            ]"
            @click="processOdd(runner, runner.outcomes, status)">
            <span
              v-if="getQuickBetNotification && getQuickBetNotification.betslip.status === 4"
              class="bto-sb-spinner-v1"></span>
            <span>{{ runner.outcomes[0].outcome | formatOddDisplay($root.oddFormat) }}</span>
          </div>
          <div class="bto-sb-horse-event-item-odd-stat" v-if="runner.prevOdds.length > 0">
            <span v-for="(outcome, idx) in runner.prevOdds.slice(0, 3)" :key="idx">{{
              outcome.outcome | formatOddDisplay($root.oddFormat)
            }}</span>
          </div>
          <div v-else class="bto-sb-horse-event-item-odd-stat">
            <span>{{ "--" }}</span>
            <span>{{ "--" }}</span>
            <span>{{ "--" }}</span>
          </div>
        </div>
        <div class="bto-sb-horse-event-item-odd" v-if="!runner.outcomes.length && betType === RACING_BETTING_TYPES.WINNER_EW" >
          <div class="bto-sb-event-odd">
            <span>{{ "--" }}</span>
          </div>
          <div class="bto-sb-horse-event-item-odd-stat" v-if="runner.prevOdds.length > 0">
            <span v-for="(outcome, idx) in runner.prevOdds.slice(0, 3)" :key="idx">{{
              outcome.outcome | formatOddDisplay($root.oddFormat)
            }}</span>
          </div>
          <div v-else class="bto-sb-horse-event-item-odd-stat">
            <span>{{ "--" }}</span>
            <span>{{ "--" }}</span>
            <span>{{ "--" }}</span>
          </div>
        </div>
        <div class="bto-sb-horse-event-item-odd" v-if="betType !== RACING_BETTING_TYPES.WINNER_EW">
          <div
            v-for="odd in getCastOdds"
            :key="odd.id"
            class="bto-sb-event-odd"
            :class="{ 'bto-sb-event-odd-active': checkCastActive(odd), 'bto-sb-odd-lock':
                  !getRunnerOutcome.isPublished  && status !== 4, }"
            @click="$emit('toggleCast', { odd, runner })">
            <span>{{ t(odd.name) }}</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import { RACE_REGION_FILE_EXTENSION } from 'bto-models/match/races/const';
  import { HORSE_RACING_STATUSES } from '../../../models/enums/horse-racing-const';
  import { truncateString } from '../../../services/utils';
  import store from '../../../store';
  import { toggleItem, isOddActive, getQuickbetPlacementMessage, placeQuickBet, raceCastState } from '@bto-services/betslip-core';
  import { mapMatchToBetslipItem, mapMatchToBetslipMatchItem, getQuickBetClass } from 'bto-models/betslip';
  import { showBetslipValidation } from '@bto-services/modal';
  import { RACING_BETTING_TYPES, RACE_RUNNERS_POSITIONS } from 'bto-models/match/races/const';

  export default {
    name: "HrRaceOdds",
    data() {
      return {
        hrStatuses: HORSE_RACING_STATUSES,
        imgSrc: '',
        altImgSrc: '',
        showImg: false,
        RACING_BETTING_TYPES,
      };
    },
    props: {
      runner: {
        type: Object,
        required: true,
      },
      status: {
        type: Number,
        required: true,
      },
      selectedSport: {
        type: Number,
        required: true,
      },
      raceRegion: {
        type: String,
        default: 'uk',
      },
      raceType: {
        type: String,
      },
      tournamentId: {
        type: String,
      },
      betType: {
        type: Number,
        default: RACING_BETTING_TYPES.WINNER_EW 
      },
    },
    computed: {
      getCastOdds() {
         if (this.betType === RACING_BETTING_TYPES.FORECAST) {
          return [
            { name: 'Public.First', id: RACE_RUNNERS_POSITIONS.FIRST },
            { name: 'Public.Second', id: RACE_RUNNERS_POSITIONS.SECOND },
            { name: 'Public.Any', id: RACE_RUNNERS_POSITIONS.ANY }
          ];
        }
        if (this.betType === RACING_BETTING_TYPES.TRICAST) {
           return [
            { name: 'Public.First', id: RACE_RUNNERS_POSITIONS.FIRST },
            { name: 'Public.Second', id: RACE_RUNNERS_POSITIONS.SECOND },
            { name: 'Public.Third', id: RACE_RUNNERS_POSITIONS.THIRD },
            { name: 'Public.Any', id: RACE_RUNNERS_POSITIONS.ANY }
          ];
        }
        return [];
      },
      isOddSelected() {
        return isOddActive({ matchId: this.getRunnerOutcome.oid, marketId: this.getRunnerOutcome.outcomeId, outcomeId: this.getRunnerOutcome.competitorId });
      },
      getRunnerOutcome() {
        return (this.runner.outcomes && this.runner.outcomes[0]) || {
          outcome: 0,
          id: 0,
          outrightId: 0,
          outcomeId: 0,
        };
      },
      horseRacingSportId() {
        return store.state.SportsModule.hrSportId;
      },
      greyhoundRacingSportId() {
        return store.state.SportsModule.ghSportId;
      },
      getQuickBetNotification() {
        return getQuickbetPlacementMessage({ matchId: this.getRunnerOutcome.oid, marketId: this.getRunnerOutcome.outcomeId, outcomeId: this.getRunnerOutcome.competitorId });
      },
      quickBetClasses() {
        return getQuickBetClass(this.getQuickBetNotification);
      },
    },
    created() {
      this.getImageUrl();
    },
    methods: {
      checkCastActive(odd) {
        if (odd.id === 'Any') {
          return raceCastState.any.some(ai => ai.id === this.runner.externalRunnerID);
        }
        const idx = (+odd.id) - 1;
        return raceCastState.regular[idx].id === this.runner.externalRunnerID; 
      },
      setAltImg() {
        this.showImg = true;
      },
      getImageUrl() {
        const isHorseRacing = this.selectedSport === this.horseRacingSportId;
        if (isHorseRacing) {
          this.imgSrc = `${APP_SETTINGS.path.baseUrl}/images/horse/4.png`;
          const url = `${APP_SETTINGS.path.horseImageUrl}${this.runner.jockeyFileName}`;
          this.altImgSrc = url;
          return;
        }
        const rn = this.runner.runnerNumber;
        const fileExtenstion = RACE_REGION_FILE_EXTENSION[this.raceRegion] || 'svg';
        this.imgSrc = `${APP_SETTINGS.path.baseUrl}/images/greyhounds/${rn}dog-${this.raceRegion}.${fileExtenstion}`;
      },
      processOdd(match, outcome) {
        if (this.checkInvalidOdd(outcome[0])) {
          return;
        }
        const betMatch = {
          ...match,
          sportId: this.selectedSport,
          id: outcome[0].oid,
          outcomeId: outcome[0].outcomeId,
        }
        // If outcome is not selected add outcome to betslip
        const betslipItem = mapMatchToBetslipItem(
          betMatch,
          {
            ...outcome[0],
            name: match.name,
            id: outcome[0].competitorId,
            oddTypeOutcomeId: outcome[0].id,
          },
          {
            marketName: outcome[0].name,
          },
          true,
          false,
          true);
        const betslipMatchItem = mapMatchToBetslipMatchItem(betMatch, true, true);
        betslipMatchItem.rTournamentId = this.tournamentId;
        const error = toggleItem(betslipItem, betslipMatchItem);
        showBetslipValidation(error);
        if (this.isOddSelected) {
          placeQuickBet(betslipItem);
        }
      },
      checkInvalidOdd(odd, status) {
        return status === HORSE_RACING_STATUSES.RUNNING
          || status === HORSE_RACING_STATUSES.RESULTS
          || odd.isPublished === false
          || (+odd.outcome) === 0
          || (+odd.outcome) === 1
          || !odd.id;
      },
      truncateString,
    },
  };
</script>
